import type { ColumnDef } from "@tanstack/react-table";
import type { ApEmail } from "@/accounts-payable/types";

export const fromCol: ColumnDef<ApEmail> = {
  id: "from",
  header: "From",
  accessorFn: (row) => row.from,
  meta: { size: "240px" },
  // Addresses don't wrap, so a long one would run into Subject; the side
  // panel shows it in full.
  cell: ({ row }) => (
    <span className="block truncate font-medium" title={row.original.from}>
      {row.original.from}
    </span>
  ),
};
